import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-slot-table-item',
    templateUrl: './slot-table-item.component.html',
    styleUrls: ['./slot-table-item.component.css'],
    standalone: false
})
export class SlotTableItemComponent implements OnInit {

  @Input() slot: number;
  @Output() slotChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() allowedPersons: number;
  @Output() allowedPersonsChange: EventEmitter<number> = new EventEmitter<number>();

  private _originalAllowedPersons: number;
  private _originalSlot: number;

  constructor() { }

  ngOnInit(): void {
    this._originalAllowedPersons = this.allowedPersons;
    this._originalSlot = this.slot;
  }

  onSlotTimeChange() {
    if (this.slot === null) {
      this.allowedPersons = null;
      this.allowedPersonsChange.emit(this.allowedPersons);
    } else {
      if (this._originalSlot !== null) {
        this.allowedPersons = this._originalAllowedPersons;
        this.allowedPersonsChange.emit(this.allowedPersons);
      }
    }
    this.slotChange.emit(this.slot);
  }

  onAllowedPersonsChange() {
    this.allowedPersonsChange.emit(this.allowedPersons);
  }

}
